import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Badge,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Hotel,
  Map as MapPin,
  Headset as Headphones,
  TrendingUp,
  Shield,
} from "@mui/icons-material";
import { DirectionsBus as Bus } from "@mui/icons-material";
import { ConfirmationNumber as Ticket } from "@mui/icons-material";   //
import { AirplanemodeActive as Plane } from "@mui/icons-material";


export function VoucherDetailsSection() {
  const voucherTiers = [
    {
      tier: "Explorer Partner",
      discount: "12%",
      minBookings: "50 bookings/year",
      services: "Ground Transport, Tour Support",
      validity: "12 months",
      status: "Active",
    },
    {
      tier: "Traveler Partner",
      discount: "18%",
      minBookings: "150 bookings/year",
      services: "Ground + Accommodation Support",
      validity: "12 months",
      status: "Active",
    },
    {
      tier: "Voyager Partner",
      discount: "24%",
      minBookings: "300 bookings/year",
      services: "Full Logistics + Priority Support",
      validity: "12 months",
      status: "Active",
    },
    {
      tier: "Elite Partner",
      discount: "30%",
      minBookings: "500+ bookings/year",
      services: "Complete Package + Concierge",
      validity: "18 months",
      status: "Active",
    },
  ];

  const benefits = [
    {
      icon: Bus,
      title: "Ground Transportation",
      description:
        "Exclusive discounts on buses, coaches, and private vehicle logistics",
    },
    {
      icon: Hotel,
      title: "Accommodation Support",
      description:
        "Preferential rates and guaranteed availability for partner hotels",
    },
    {
      icon: Ticket,
      title: "Tour Vouchers",
      description:
        "Discounted entry tickets, activity passes, and experience vouchers",
    },
    {
      icon: Plane,
      title: "Travel Coordination",
      description:
        "Seamless flight bookings and airport transfer arrangements",
    },
    {
      icon: Headphones,
      title: "24/7 Support",
      description:
        "Round-the-clock dedicated logistics support and emergency assistance",
    },
    {
      icon: MapPin,
      title: "Local Expertise",
      description:
        "Access to local guides, destination experts, and ground handlers",
    },
    {
      icon: TrendingUp,
      title: "Revenue Growth",
      description: "Marketing support and co-promotional opportunities",
    },
    {
      icon: Shield,
      title: "Insurance Coverage",
      description: "Complimentary travel insurance options for partner bookings",
    },
  ];

  const servicesIncluded = [
    "Airport Meet & Greet Services",
    "Hotel Check-in/Check-out Coordination",
    "Multi-destination Itinerary Planning",
    "Group Tour Logistics Management",
    "Emergency Support & Assistance",
    "Real-time Booking Management System",
    "Customized Travel Documentation",
    "Visa & Travel Permit Assistance",
  ];

  return (
    <Box sx={{ p: {xs: 1, lg: 4 }}}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom >
          Partnership Voucher & Logistics Program
        </Typography>
        <Typography color="text.secondary">
          Our comprehensive partnership program provides travel agencies, tour
          operators, and travel businesses with exclusive voucher benefits and
          complete logistics support to streamline operations and enhance
          customer experiences.
        </Typography>
      </Box>

      {/* Benefits Grid */}
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {benefits.map(({ icon: Icon, title, description }, idx) => (
          <Grid key={idx} item xs={12} sm={6} md={3}>
            <Card variant="outlined" sx={{ height: "100%" }}>
              <CardHeader
                avatar={<Icon color="primary" fontSize="large" />}
                title={<Typography variant="h6">{title}</Typography>}
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Voucher Tiers Table 
      <Card sx={{ mb: 6 }}>
      
        <CardContent>
          

          <Box
            sx={{
              mt: 4,
              p: 3,
              backgroundColor: "#BBDEFB" ,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "primary.main",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Logistics Services Included:
            </Typography>
            <List>
              {servicesIncluded.map((service, i) => (
                <ListItem key={i}>
                  <ListItemIcon>
                    <CheckCircleIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={service} />
                </ListItem>
              ))}
            </List>
          </Box>

          <Box
            sx={{
              mt: 4,
              p: 3,
              backgroundColor: "grey.100",
              borderRadius: 1,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Terms & Conditions:
            </Typography>
            <List>
              <ListItem>Partnership vouchers are valid for the duration specified in each tier level</ListItem>
              <ListItem>Minimum booking volume must be maintained annually to retain tier status</ListItem>
              <ListItem>Discounts apply to ground transportation, accommodation, tour activities, and logistics services</ListItem>
              <ListItem>Vouchers are non-transferable and applicable only to partner-initiated bookings</ListItem>
              <ListItem>Partnership agreements are subject to annual performance review and renewal</ListItem>
              <ListItem>Advanced booking (72 hours minimum) recommended for guaranteed service availability</ListItem>
              <ListItem>Seasonal peak periods may have limited voucher applicability (advance notification provided)</ListItem>
              <ListItem>Additional customized services available upon request with preferential pricing</ListItem>
            </List>
          </Box>
        </CardContent>
      </Card>*/}

      {/* Additional Value Proposition 
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              background: "linear-gradient(to bottom right, #ebf8ff, #cff4fc)",
            }}
            variant="outlined"
          >
            <CardHeader title="Nationwide Coverage" />
            <CardContent>
              <Typography color="text.secondary">
                Access our extensive network across 50+ destinations with local
                logistics partners in every major tourist location.
              </Typography>
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => alert("Learn more about coverage")}
              >
                Learn More
              </Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              background: "linear-gradient(to bottom right, #e6f4ea, #d1edd6)",
            }}
            variant="outlined"
          >
            <CardHeader title="Quality Assurance" />
            <CardContent>
              <Typography color="text.secondary">
                All logistics partners are vetted and certified. We maintain strict
                quality standards and regular performance audits.
              </Typography>
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => alert("Learn more about quality assurance")}
              >
                Learn More
              </Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              background: "linear-gradient(to bottom right, #fff4e6, #ffe4c7)",
            }}
            variant="outlined"
          >
            <CardHeader title="Technology Platform" />
            <CardContent>
              <Typography color="text.secondary">
                Access our online booking portal with real-time availability, instant
                confirmations, and comprehensive reporting tools.
              </Typography>
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={() => alert("Learn more about technology")}
              >
                Learn More
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}
    </Box>
  );
}
